module.exports = __webpack_public_path__ + "static/img/4.6e49e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/img/feature/4.jpg
// module id = xUKW
// module chunks = 1